import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { messaging } from '../../firebase'; 
import { getToken } from 'firebase/messaging';
import { doc, setDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import LoadingScreen from '../core/LoadingScreen';

const AuthGate = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (user) {
      const requestPermission = async () => {
        try {
          if ('permission' in Notification) {
            const permission = await Notification.requestPermission();
            if (permission === 'granted') {
              const token = await getToken(messaging, { vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY });
              if (token) {
                await setDoc(doc(db, 'users', user.uid), { fcmToken: token }, { merge: true });
              }
            }
          }
        } catch (error) {
          console.error('Error getting permission or token:', error);
        }
      };
      requestPermission();
    }
  }, [user]);

  if (loading) {
    return <LoadingScreen />;
  }

  if (!user) {
    // Not logged in.
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Check if profile has name and class
  const isProfileComplete = user.name && user.class;

  if (isProfileComplete) {
    // Profile is complete.
    // If they are on the name verification page, redirect them to the app.
    if (location.pathname === '/name-verification') {
      return <Navigate to="/all-records" replace />;
    }
    // Otherwise, render the requested protected page.
    return children;
  } else {
    // Profile is incomplete.
    // If they are NOT on the name verification page, force them there.
    if (location.pathname !== '/name-verification') {
      return <Navigate to="/name-verification" replace />;
    }
    // Otherwise, render the name verification page.
    return children;
  }
};

export default AuthGate;